import React from 'react';
import DateRangeSelector from './DateRangeSelector';
import { SyncStatus } from '../services/syncService';
import './PageHeader.css';

interface PageHeaderProps {
  title: string;
  showControls: boolean;
  onDateRangeChange: (startDate: string, endDate: string) => void;
  initialStartDate?: string;
  initialEndDate?: string;
  isSyncing?: boolean;
  syncStatus: SyncStatus | null;
  onRefresh?: () => void;
}

function formatSyncLabel(isSyncing: boolean, syncStatus: SyncStatus | null): string {
  if (isSyncing) return 'Actualizando…';
  if (!syncStatus?.lastSyncTime) return 'Sin sincronizar';

  const hours = syncStatus.hoursAgo ?? 0;
  if (hours < 1 / 60) return 'hace unos momentos';
  if (hours < 1) return `hace ${Math.max(1, Math.round(hours * 60))} min`;
  if (hours < 24) return `hace ${hours.toFixed(1)} h`;
  return `hace ${Math.round(hours / 24)} d`;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  showControls,
  onDateRangeChange,
  initialStartDate,
  initialEndDate,
  isSyncing = false,
  syncStatus,
  onRefresh,
}) => (
  <header className="page-header">
    <div className="page-header-main">
      <h1 className="page-header-title">{title}</h1>

      {showControls && (
        <>
          <div className="page-header-center">
            <DateRangeSelector
              variant="header"
              onDateRangeChange={onDateRangeChange}
              initialStartDate={initialStartDate}
              initialEndDate={initialEndDate}
            />
          </div>

          <div className="page-header-actions">
            <div className="page-header-sync">
              <span className="page-header-sync-dot" aria-hidden="true" />
              <span className="page-header-sync-label">{formatSyncLabel(isSyncing, syncStatus)}</span>
            </div>
            <button
              type="button"
              className="page-header-refresh"
              onClick={onRefresh}
              disabled={isSyncing}
              title="Actualizar datos"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M21 2v6h-6" />
                <path d="M3 12a9 9 0 0 1 15.5-6.36L21 8" />
                <path d="M3 22v-6h6" />
                <path d="M21 12a9 9 0 0 1-15.5 6.36L3 16" />
              </svg>
              Actualizar
            </button>
          </div>
        </>
      )}
    </div>
  </header>
);

export default PageHeader;
